import request from "@/router/axios";
//  通用路径:/produce/all-staff-efficiency  

// 获取全员效率统计数据
export const getallStaffEfficiency = (data) => {
    console.log(data,'params0987');
    return request({
        url: "/api/produce/all-staff-efficiency/statistics",
        method: "post",
        data,
    });
};
// 动态所有表格接口
export const getList = (params, type = 'details') => {
    return request({
        url: `/api/produce/all-staff-efficiency/${type}`,
        method: "post",
        data: params,
    });
};

// 查询工时分布
export const getWorkHourDistribution = (data) => {
    return request({
        url: "/api/produce/all-staff-efficiency/work-hour-distribution",
        method: "post",
        data,
    });
};
// 查询工时趋势
export const getWorkHourTrend = (data) => {
    return request({
        url: "/api/produce/all-staff-efficiency/work-hour-trend",
        method: "post",
        data,
    });
};
// 查询整体完成率
export const getPositionCompletionRate = (params) => {
    return request({
        url: "/api/produce/all-staff-efficiency/position-completion-rate",
        method: "post",
        params,
    });
};

// 查询岗位完成率排名




// 查询人均产出排名
export const getPerCapitaOutputRanking = (params) => {
    return request({
        url: "/api/produce/all-staff-efficiency/per-capita-output-ranking",
        method: "post",
        data: params,
    });
};

// 查询产出趋势变化
export const getOutputTrend = (params) => {
    return request({
        url: "/api/produce/all-staff-efficiency/output-trend",
        method: "post",
        data: params,
    });
};
// 查询多维度效率指标分析

// 查询班组效率分布热力图
export const getTeamEfficiencyHeatmap = (params) => {
    return request({
        url: "/api/produce/all-staff-efficiency/team-efficiency-heatmap",
        method: "post",
        data: params,
    });
};